var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"access-updated test-completed animation",class:{ accessShow: _vm.popup}},[_c('div',{staticClass:"fade-out flip",class:{ popupShow: _vm.popup, popupActive: _vm.popupActive }},[_c('p',[_vm._v(_vm._s(_vm.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }